<template>
	<div :class="'input-item ' + classList + ' ' + containerClasses" :style="styles">
		<label class="input-label" :for="id" v-if="label !== ''"
			>{{ label }} <span class="asterisk" v-if="asterisk">*</span>
			<icon type="help" class="not-mobile help-icon-for-field" v-if="help !== ''" :tooltip="help"></icon
		></label>
		<div
			class="input-field-block"
			@dragover.prevent="dragover($event)"
			@dragleave="hovering = false"
			@drop.prevent="dropFile($event)"
		>
			<input
				style="display: none"
				:accept="accept"
				:tabindex="tabindex"
				@focus="focus"
				@blur="blur"
				@change="update($event)"
				@keydown.tab="keypressTab($event)"
				type="file"
				:id="id"
				:name="name"
				ref="file_input"
				:class="'input ' + classList + ' ' + extraClasses"
				:autofocus="autofocus"
				:readonly="readonly"
				:disabled="disabled"
				:required="required"
				:multiple="multiple"
			/>
			<btn type="outline" style="width: 100%" :class="buttonClasses" @click="triggerInput">
				<icon type="upload" color="inherit"></icon>
				{{ placeholder }}
			</btn>
		</div>
		<p class="input-help error" v-if="error" v-html="error"></p>
		<p class="input-help only-mobile" v-if="help !== ''" v-html="help"></p>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
		id: { default: "" },
		name: { default: "" },
		value: {},
		accept: { default: "" },

		label: { default: "" },
		help: { default: "" },
		error: { default: false },
		tabindex: { default: null },
		multiple: { default: false },

		preventEnter: { default: false },
		asterisk: { default: false },
		required: { default: false },
		disabled: { default: false },
		readonly: { default: false },
		autofocus: { default: false },

		clearable: { default: false },
		hasError: { default: false },
		hasSuccess: { default: false },
		isLoading: { default: false },
		isFull: { default: false },
		isModel: { default: true },

		type: { default: "text" }, // default input types
		extraClasses: { default: "" },
		containerClasses: { default: "" },
		width: { default: null },
		size: { default: "regular" }, // regular, large
	},

	watch: {
		value: function (value) {
			if (value.length === 0) {
				this.files = [];
				this.$refs.file_input.value = "";
			}
		},
	},

	data: function () {
		return {
			hovering: false,
			hasFocus: false,
			files: [],
		};
	},

	methods: {
		update(e) {
			this.files = Array.from(e.target.files);
			this.$emit("input", this.files);
		},

		dragover(event) {
			const dataTransfer = event.dataTransfer;

			if (
				dataTransfer.types &&
				(dataTransfer.types.indexOf
					? dataTransfer.types.indexOf("Files") !== -1
					: dataTransfer.types.contains("Files"))
			) {
				this.hovering = true;
			}
		},

		dropFile(event) {
			this.hovering = false;
			this.files = [];
			const dataTransfer = event.dataTransfer;

			if (this.multiple && dataTransfer.items && dataTransfer.items.length > 0) {
				for (let i = 0; i < dataTransfer.items.length; i++) {
					if (dataTransfer.items[i].kind === "file") {
						this.files.push(dataTransfer.items[i].getAsFile());
					}
				}
			} else if (dataTransfer.files.length > 0) {
				this.files.push(dataTransfer.files[0]);
			}

			this.$emit("input", this.files);
		},

		keypressTab(e) {
			this.$emit("tab", e);
		},

		iconClicked(e) {
			this.$emit("icon-clicked", e);
		},

		focus() {
			this.hasFocus = true;
			this.$emit("focus");
		},

		triggerInput() {
			this.$refs.file_input.click();
		},

		blur() {
			this.hasFocus = false;
			this.$emit("blur");
		},
	},

	computed: {
		styles() {
			let style = {};

			if (this.width !== null) {
				style["width"] = this.width;
			}

			return style;
		},

		buttonClasses() {
			let classList = "height-" + this.size;

			if (this.hovering) {
				classList += " drag-over";
			}

			return classList;
		},

		classList() {
			let classList = "";

			classList += " size-" + this.size;
			classList += " type-" + this.type;
			classList += " text-" + this.textDirection;

			if (this.suffix !== "") {
				classList += " has-suffix";
			}

			if (this.label !== "") {
				classList += " has-label";
			}

			if (this.help !== "") {
				classList += " has-help";
			}

			if (this.hasSuccess) {
				classList += " has-success";
			}

			if (this.hasError || this.error) {
				classList += " has-error";
			}

			if (this.isLoading) {
				classList += " is-loading";
			}

			if (this.isFull) {
				classList += " is-full";
			}

			if (this.required) {
				classList += " is-required";
			}

			if (this.hasFocus) {
				classList += " has-focus";
			}

			return classList;
		},

		placeholder() {
			return this.files.length > 0
				? lang.get("actions.fields.selected_file" + (this.files.length > 1 ? "s" : "")) +
						Array.from(this.files)
							.map((file) => {
								return file.name;
							})
							.join(", ")
				: lang.get("actions.fields.select_file");
		},
	},
};
</script>

<style lang="scss">
.button.drag-over {
	outline: none;
	border-color: #7061ff;
	box-shadow: 0 0 0 0.2rem rgba(#7061ff, 0.25);
}
</style>
